module.exports = __webpack_public_path__ + "img/59.d953a5c7.jpg";